export default __webpack_public_path__ + "static/media/hide-icon.f878c823.svg";